module.exports = __webpack_public_path__ + "static/media/favicon-single-parent-meet.696ee73d.ico";